import { dialogPageTakeoverWidth } from '@atlassian/search-dialog';

export const useIsMobileView = (): boolean => window.innerWidth <= dialogPageTakeoverWidth;
